import moment from 'moment'

// Back-dated EMI and down payments: while locked (Settings > Payment Settings,
// api/vsdigi/settings/backdate/*) a date before the lock date the admin chose
// (the 1st of the current month when none) is blocked; once an admin unlocks it
// any date is allowed until it is locked again.
// The server checks the same rule (BackdateLock::check).
export default {
    data() {
        return { backdateUnlocked: false, backdateLockDate: null }
    },
    mounted() { this.loadBackdateStatus() },
    methods: {
        loadBackdateStatus() {
            return window.axios.post('api/vsdigi/settings/backdate/status')
                .then(response => {
                    const data = response.data || {}
                    this.backdateUnlocked = !!data.unlocked
                    this.backdateLockDate = data.lockdate || null
                })
                .catch(error => {
                    console.log(error)
                    this.backdateUnlocked = false
                })
        },
        // Earliest date allowed while locked (YYYY-MM-DD)
        backdateMonthStart() {
            return this.backdateLockDate || moment().startOf('month').format('YYYY-MM-DD')
        },
        // Earliest date the picker offers. `keep` is a date already saved on the
        // record (editing a sale), which stays selectable.
        backdateMinDate(keep) {
            if (this.backdateUnlocked) return null
            const lockDate = this.backdateMonthStart()
            const from = keep && keep < lockDate ? keep : lockDate
            return moment(from, 'YYYY-MM-DD').toDate()
        },
        // True when `date` may be used; otherwise shows why and returns false.
        checkBackdate(date, keep, label) {
            const day = date ? String(date).slice(0, 10) : ''
            if (!day || day >= this.backdateMonthStart()) return true
            if (keep && day == String(keep).slice(0, 10)) return true
            if (this.backdateUnlocked) return true
            this.$notify({
                text: (label || 'Date') + ' cannot be before ' + moment(this.backdateMonthStart(), 'YYYY-MM-DD').format('DD-MM-YYYY')
                    + '. Ask an admin to unlock back-dated payments in Settings > Payment Settings.',
                type: 'error',
                duration: '8000',
            })
            return false
        },
    },
}
